
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.946 8.968a.771.771 0 00-1.091-1.09L3.74 11.991a.771.771 0 000 1.09l4.115 4.115a.771.771 0 101.09-1.091l-2.797-2.797h7.704c.255 0 .462-.346.462-.772 0-.426-.207-.771-.463-.771H6.148l2.798-2.798zm8.843-3.94h-8.96c-.379 0-.686-.345-.686-.77 0-.427.307-.772.686-.772h8.96c1.476 0 2.697 1.249 2.697 2.828v12.343c0 1.58-1.221 2.829-2.697 2.829h-8.96c-.379 0-.686-.346-.686-.772 0-.426.307-.771.686-.771h8.96c.746 0 1.325-.593 1.325-1.286V6.314c0-.693-.58-1.285-1.325-1.285z"}})])
          )
        }
      }
    